import { get } from 'vuex-pathify';
export default {
  computed: {
    masterplanStreetsSituationCopyVerboseName: get('admin/additionalModules@MASTERPLAN_2_STREETS.verbose_name'),
    isMasterplanStreetsModuleEnabled: get('admin/additionalModules@MASTERPLAN_2_STREETS.enabled'),
    isMasterplanStreetsSettingEnabled: get('admin/settingsValues@masterplan_2_streets_module_enabled'),
    masterplanStreetsTwoDS: get('admin/modulesMapping@masterplan_2_streets.masterplan_street_datasource.datasource'),
    hasMasterplanStreetsPermissions() {
      return this.$store.get('users/toolsPermissions')['MASTERPLAN_2_STREETS'].main_value > 0;
    },
    isMasterStreetsVisible() {
      return (
        this.currentLayer?.data_source_name === this.masterplanStreetsTwoDS &&
        this.isMasterplanStreetsModuleEnabled &&
        this.isMasterplanStreetsSettingEnabled &&
        this.hasMasterplanStreetsPermissions
      );
    },
    masterplanStreetsButton() {
      return this.isMasterStreetsVisible
        ? [
            {
              name: 'masterplanStreetsSituationCopy',
              icon: '$roadCopy',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('sidebar.masterplanStreets.copySituationToSelected')
                : this.$i18n.t('button.toUseTool', {
                    suffix: this.$i18n.t('button.atLeastOneSelected'),
                  }),
              fontSize: '19px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
  },
  data: () => ({
    isMasterplanStreetsSituationCopyLoaded: false,
    isMasterplanStreetsSituationCopyVisible: false,
  }),
  methods: {
    masterplanStreetsSituationCopyAction() {
      this.isMasterplanStreetsSituationCopyLoaded = true;
      this.isMasterplanStreetsSituationCopyVisible = true;
    },
  },
};
